import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Log environment variable status (helpful for debugging)
console.log('Environment check:', {
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseAnonKey,
  url: supabaseUrl ? supabaseUrl.substring(0, 20) + '...' : 'missing'
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Missing Supabase environment variables!');
  console.error('Please set the following in Netlify Dashboard > Site settings > Environment variables:');
  console.error('- REACT_APP_SUPABASE_URL=your-project-url');
  console.error('- REACT_APP_SUPABASE_ANON_KEY=your-anon-key');
  console.error('\nThe app will continue to load but authentication will not work.');
}

// Create Supabase client with fallback values to prevent crashes
// Using placeholder values if env vars are missing (won't work but won't crash)
const safeUrl = supabaseUrl || 'https://placeholder.supabase.co';
const safeKey = supabaseAnonKey || 'placeholder-key';

export const supabase = createClient(safeUrl, safeKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  }
});

// Export a helper to check if Supabase is properly configured
export const isSupabaseConfigured = (): boolean => {
  return !!(supabaseUrl && supabaseAnonKey);
};

// Database types for TypeScript
export interface Database {
  public: {
    Tables: {
      customs_brokers: {
        Row: {
          id: number;
          name: string;
          website: string;
          created_at: string;
        };
      };
      fcl_export_shipments: {
        Row: {
          id: number;
          shipment_number: string;
          customs_broker_id: number;
          shipment_type: string;
          status: string;
          origin_port: string;
          destination_port: string;
          port_of_loading: string;
          port_of_discharge: string;
          place_of_delivery: string | null;
          place_of_receipt: string | null;
          expected_sailing_date: string | null;
          estimated_arrival_date: string | null;
          shipper_name: string | null;
          shipper_address: string | null;
          consignee_name: string | null;
          consignee_address: string | null;
          notify_party_name: string | null;
          vessel: string | null;
          voyage: string | null;
          container_details: string | null;
          gross_weight: string | null;
          created_at: string;
          updated_at: string;
        };
      };
      bol_drafts: {
        Row: {
          id: number;
          shipment_id: number;
          draft_data: any;
          created_at: string;
          updated_at: string;
        };
      };
    };
  };
}
